import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
import React, { memo } from 'react';
import { Container, SubNewsWrapper } from 'app/components/topNewsModule/subNews/subNewsStyles';
import SubNews from 'app/components/topNewsModule/subNews/SubNews';
import { fillArrayToSize } from 'app/components/swipeableViews/splitArrayIntoChunks';
function NewsView(_ref) {
  let {
    news,
    listLength,
    pageIndex = 0
  } = _ref;
  const {
    trackClickedItemPage
  } = useDistrictMainPageTracking();
  const newsWithFiller = news.length < listLength ? fillArrayToSize(news, listLength) : news;
  const handleClick = () => {
    trackClickedItemPage(DistrictMainPageModuleType.TOPNEWS, pageIndex);
  };
  return /*#__PURE__*/React.createElement(Container, {
    onClick: handleClick,
    "data-sentry-element": "Container",
    "data-sentry-component": "NewsView",
    "data-sentry-source-file": "NewsView.tsx"
  }, newsWithFiller.map((newsData, elementIndex) => {
    if (!newsData) {
      return /*#__PURE__*/React.createElement(SubNewsWrapper, {
        "data-testid": "news-filler",
        key: "news-filler-".concat(elementIndex)
      });
    }
    return /*#__PURE__*/React.createElement(SubNews, {
      key: "sub-news-".concat(newsData.news.id),
      data: newsData
    });
  }));
}
export default /*#__PURE__*/memo(NewsView);